import $ from 'jquery'
import {Core} from "./core.js";

export class Modal {

  constructor () {
    this.$html = $('html')

    this.$html.on('click', 'a.link-modal', this.handleOpenModal.bind(this))
    this.$html.on('click', '.modal .modal-overlay, .modal #button-close-modal', this.handleCloseModal.bind(this))
  }

  handleOpenModal (e) {
    e.preventDefault()
    let $element = $(e.currentTarget)
    let action = $element.attr('data-modal')
    let $modal = $('.modal[data-action="' + action + '"]')

    // Custom modal action
    // if (action === 'ajax-job') {
    //   this.job();
    // }

    $modal.addClass('open')
    Core.disableBodyScroll()
  }

  handleCloseModal (e) {
    e.preventDefault()
    let $modal = $(e.target).closest('.modal')

    if ($modal.hasClass('open')) {
      $modal.removeClass('open')
      Core.activeBodyScroll()
    }
  }
}
